import React from 'react';
import { Accordion } from './Accordion';
interface ObjectionsProps {
  onCTAClick: () => void;
}
export function Objections({
  onCTAClick
}: ObjectionsProps) {
  const objections = [{
    title: '❓ ¿Es un curso o material descargable?',
    content: <p data-id="element-103">
          Es material descargable en formato PDF. No es un curso con clases. Son
          4 tomos completos + 6 bonos con plantillas editables, modelos,
          registros y guías prácticas que podés usar de inmediato. Lo descargás
          y es tuyo para siempre.
        </p>
  }, {
    title: '❓ ¿Sirve si recién empiezo como acompañante?',
    content: <p data-id="element-104">
          ¡Absolutamente! De hecho, es ideal para quienes están comenzando
          porque te da toda la estructura profesional desde el día uno. Vas a
          tener modelos claros de informes, registros organizados y estrategias
          probadas sin tener que improvisar o buscar por todos lados.
        </p>
  }, {
    title: '❓ ¿Las plantillas son editables?',
    content: <p data-id="element-105">
          Sí, todas las plantillas son 100% editables. Podés adaptarlas a tus
          necesidades específicas, agregar tu información, modificar los campos
          y personalizarlas para cada alumno o situación. Están diseñadas para
          que las uses como base y las hagas tuyas.
        </p>
  }, {
    title: '❓ ¿Cómo lo recibo?',
    content: <p data-id="element-106">
          El acceso es inmediato. Apenas confirmás tu compra, recibís un email
          con el link de descarga. Podés descargar todo el material en el
          momento y empezar a usarlo de inmediato. No hay esperas ni envíos
          físicos.
        </p>
  }, {
    title: '❓ ¿Funciona para todos los niveles educativos?',
    content: <p data-id="element-107">
          Sí, el material incluye adaptaciones y recursos para nivel inicial,
          primaria y secundaria. El Bono 1 (Atlas de Adaptaciones) está
          específicamente organizado por nivel escolar, y las estrategias son
          aplicables en cualquier contexto educativo.
        </p>
  }];
  return <section className="w-full bg-white py-16 px-4" data-id="element-108">
      <div className="max-w-4xl mx-auto" data-id="element-109">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-110">
          Preguntas Frecuentes
        </h2>

        <Accordion items={objections} data-id="element-111" />

        <div className="mt-10 flex justify-center" data-id="element-112">
          <button onClick={onCTAClick} className="bg-teal-600 hover:bg-teal-700 text-white font-bold py-4 px-8 rounded-lg text-lg shadow-lg hover:shadow-xl transition-all" data-id="element-113">
            Empezá a ahorrar horas
          </button>
        </div>
      </div>
    </section>;
}